import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as bootstrap from 'bootstrap';
import './Navi.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import AuthService from '../../services/authService';

const Navi = ({ title }) => {
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 991);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    const handleLogout = () => {
        AuthService.logout();
        navigate('/login');
    };

    // const handleMenuClick = () => {
    //     const modal = document.getElementById('right-modal');
    //     if (modal) {
    //         const modalInstance = bootstrap.Modal.getInstance(modal);
    //         if (modalInstance) {
    //             modalInstance.hide();
    //         }
    //     }

    //     // 💡 backdrop 수동 제거
    //     const backdrops = document.querySelectorAll('.modal-backdrop');
    //     backdrops.forEach(el => el.parentNode.removeChild(el));

    //     // 💡 body의 modal-open 클래스도 제거
    //     document.body.classList.remove('modal-open');
    //     document.body.style = ''; // 스크롤 막힘도 초기화
    // };
    return (
        <>
            <div className="navbar-custom admin-shell-nav">
                {/* <!-- LOGO --> */}
                <div className="logo-box">
                    <Link
                        to="/users"
                        className={`logo logo-light admin-nav-brand${isMobile ? ' admin-nav-brand--compact' : ''}`}
                    >
                        <span className="admin-nav-brand-mark" aria-hidden="true" />
                        <span className="admin-nav-brand-text">
                            <span className="admin-brand-wordmark">TSAD</span>
                            <span className="admin-brand-divider" aria-hidden="true" />
                            <span className="admin-brand-tagline">관리자</span>
                        </span>
                    </Link>
                </div>

                <ul
                    className="list-unstyled topnav-menu topnav-menu-left mb-0 "
                    style={{ float: isMobile ? 'right' : 'left' }}
                >
                    <li>
                        <div className="dropdown">
                            <button
                                className="button-menu-mobile disable-btn waves-effect dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                type="button"
                            >
                                <i className="fe-menu"></i>
                            </button>

                            <div className="dropdown-menu user-pro-dropdown">
                                <Link to="/users" className="dropdown-item">
                                    <i className="mdi mdi-account-cog"></i> <span>사용자관리</span>
                                </Link>
                                <Link to="/admins" className="dropdown-item">
                                    <i className="mdi mdi-account-tie"></i> <span>관리자관리</span>
                                </Link>
                                <Link to="/loginlogs" className="dropdown-item">
                                    <i className="mdi mdi-database-lock"></i> <span>접속로그</span>
                                </Link>
                                <Link to="/logs" className="dropdown-item">
                                    <i className="mdi mdi-database-search"></i>{' '}
                                    <span>검색로그</span>
                                </Link>
                                {/* <Link to="/QuotaUsageLog" className="dropdown-item">
                                    <i className="mdi mdi-chart-timeline-variant"></i>{' '}
                                    <span>한도 사용량로그</span>
                                </Link> */}

                                <Link to="/settlement" className="dropdown-item">
                                    <i className="mdi mdi-file-find-outline"></i>{' '}
                                    <span>정산관리</span>
                                </Link>
                            </div>
                        </div>
                    </li>

                    <li>
                        <h4 className="page-title-main">{title}</h4>
                    </li>
                </ul>

                {/* 우측에 로그아웃 버튼 추가 */}
                <ul className="list-unstyled topnav-menu float-end mb-0">
                    <li className="dropdown notification-list">
                        <a
                            className="nav-link dropdown-toggle nav-user me-0 waves-effect waves-light"
                            href="#"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-haspopup="false"
                            aria-expanded="false"
                        >
                            <i className="fe-user"></i>
                            <span className="pro-user-name ms-1">
                                계정 <i className="mdi mdi-chevron-down"></i>
                            </span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end profile-dropdown">
                            <div className="dropdown-header noti-title">
                                <h6 className="text-overflow m-0">환영합니다!</h6>
                            </div>
                            <Link className="dropdown-item notify-item" onClick={handleLogout}>
                                <i className="fe-log-out"></i>
                                <span>로그아웃</span>
                            </Link>
                        </div>
                    </li>
                </ul>

                <div className="clearfix"></div>
            </div>
        </>
    );
};

export { Navi };
